<template>
		<div class="game-wrap">
			<div class="back" @click="goBack">返回</div>
			<iframe :src="iframeSrc" style="width: 100%; height: 100vh; border: none;"></iframe>
		</div>
</template>
<script>

export default {
	name: 'index',

	components: {},

	data(){
		return {
			iframeSrc:"https://read2.bluebirdabc.com/games/ding2"
		}
	},

	created(){

	},
	mounted() {
		// 设置 10 分钟（600,000 毫秒）后执行返回操作
		this.timer = setTimeout(() => {
			this.getResetDate();
			localStorage.setItem('studyTime',0)
			this.$router.back();
		}, 300000); // 10分钟 = 600,000毫秒
	},
	beforeDestroy() {
		// 清除定时器，防止组件销毁后仍然触发
		clearTimeout(this.timer);
	},

	computed: {

	},
	watch: {

	},
	methods: {
		goBack(){
			console.dir(3444)
			this.$router.back()
		},
		async getResetDate() {
			const res = await this.$api.getResetDate();
			if (res.data.success) {
				console.dir("清除成功")
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.game-wrap{
	iframe {
	}
	.back{
		text-align: center;
		width: 4rem;
		height: 4rem;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 100%;
		font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
		font-weight: 500;
		font-size: 1.6rem;
		line-height: 1.88rem;
		position: absolute;
		bottom: 2rem;
		left: 2rem;
		z-index: 999;
		color: #FFFFFF;
		background: rgb(100, 45, 113);
		border: 0.2rem solid #E0E0E0;
	}
}
</style>
